
import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {},
    obj: null,
    content: "",
    imageList: [],
    time: 0,
    forwardNum: -1,
    giftNum: -1,
    likeNum: -1,
    followingUserInfo: {}
  }

  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  @action async getData(mid) {
    // 47
    let sendMid = parseInt(mid)
    let res = await http.post('/withoutsign/moment/detail', { mid: sendMid })
    if (res && res.code == 0) {
      console.log(res, 'res')
      this.data.obj = res.res
      this.data.imageList = res.res.image.length > 0 && res.res.image || []
      this.data.userInfo = res.res.userInfo || {}
      this.data.content = res.res.content || ''
      this.data.time = res.res.ts || 0
      this.data.forwardNum = res.res.forwardNum || 0
      this.data.giftNum = res.res.giftNum || 0
      this.data.likeNum = res.res.likeNum || 0
      this.data.followingUserInfo = res.res.followingUserInfo || {}
    }
  }
}



// WEBPACK FOOTER //
// src/store/app/moment.js